import type { AnalyticsService } from '../../types'

import { PostHogService } from './PostHog'

export const services: AnalyticsService[] = [new PostHogService()]
